export default function Remove(props) {
    const fill = props.fill ? props.fill : '#f44336';
    const fillCross = props.fillCross ? props.fillCross : '#fafafa';

    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path
                fill={fill}
                d="M256 0C114.8 0 0 114.8 0 256s114.8 256 256 256 256-114.8 256-256S397.2 0 256 0zm0 0"
            />
            <path
                fill={fillCross}
                d="M350.3 320.1a21.3 21.3 0 11-30.2 30.2L256 286.2l-64.1 64a21.3 21.3 0 01-30.2 0 21.3 21.3 0 010-30l64.1-64.2-64-64.1a21.3 21.3 0 1130-30.2l64.2 64.1 64.1-64a21.3 21.3 0 1130.2 30L286.2 256zm0 0"
            />
        </svg>
    );
}
